import { runDemo } from "../shared/demoRunner";
import { createHeightmapScene } from "./scene";

runDemo({
    createScene: createHeightmapScene,
});
